export default __webpack_public_path__ + "static/media/Incorrect_color.ecbcbfec.svg";